export enum FeatureFlag {
  IsMaintenance = "isMaintenance",
  FitSidebar = "fit_sidebar",
  IsVehicleBuyInEnabled = "isVehicleBuyInEnabled",
  Notification = "notification",
  IsVehicleBuyInV1SyncEnabled = "isVehicleBuyInV1SyncEnabled",
  FabV1Sync = "fabV1Sync",
  CsvExport = "csvExport",
  CommandPalette = "commandPalette",
}
